<div
  class="power-up-card tw-flex tw-flex-col tw-w-full tw-border tw-rounded-lg lg:tw-rounded-[10px] tw-p-3 lg:tw-p-4 tw-border-blue-200 tw-transition-colors before:tw-opacity-0 active:before:tw-opacity-0 active:tw-border-blue-600"
  [ngClass]="{
    'tw-cursor-not-allowed': readonly(),
    'tw-cursor-pointer hover:tw-border-blue-600 lg:hover:before:tw-opacity-100': !readonly()
  }"
  role="button"
  tabindex="0"
  (click)="onClick($event)"
>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-0 lg:tw-justify-start lg:tw-gap-2 tw-mb-1">
    <div class="tw-flex tw-items-center tw-gap-2">
        @if (isSvgIcon(card().icon)) {
          <span [innerHTML]="safeSvg()" class="tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-bg-white tw-rounded-full tw-w-6 tw-h-6"></span>
        } @else if (isImageIcon(card().icon)) {
          <span class="tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-bg-white tw-rounded-full tw-w-6 tw-h-6">
            <img [src]="card().icon.src" [alt]="card().icon.alt ?? card().title" class="tw-w-[18px] tw-h-[18px]" />
          </span>
        }
        <h3 class="tw-text-gray-900 tw-text-sm lg:tw-text-base tw-font-bold tw-font-inter">
          {{ card().title }}
        </h3>
    </div>
    @if (card().pricing) {
      <span class="tw-font-inter tw-text-xs tw-font-medium tw-text-gray-700 tw-bg-white tw-rounded-[4px] tw-px-1.5 lg:tw-px-2 tw-py-[1px] tw-flex tw-items-center tw-justify-center tw-h-5">
        {{ card().pricing }}
      </span>
    }
  </div>

  <p class="tw-text-gray-700 tw-text-xs tw-font-inter">
    {{ card().description }}
  </p>

  @if (card().tagsIcons?.length) {
    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-mt-3" aria-hidden="true">
      @for (src of card().tagsIcons; track src) {
        <span class="tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-bg-white tw-rounded-full tw-shadow-sm tw-w-6 tw-h-6">
          <img [src]="src" alt="" class="tw-w-4 tw-h-4 tw-object-contain" />
        </span>
      }
    </div>
  }

  @if (card().tags?.length) {
    <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mt-3">
      @for (tag of card().tags; track tag) {
        <span class="tw-text-xs tw-font-medium tw-text-gray-100 tw-bg-[#37415199] tw-rounded-full tw-px-2 tw-py-1">
          {{ tag }}
        </span>
      }
    </div>
  }
</div>
